import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChatRegularOptionsIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M13.384 28.845 17.98 25.6H24c2.65 0 4.8-2.15 4.8-4.8V9.6c0-2.65-2.15-4.8-4.8-4.8H8c-2.65 0-4.8 2.15-4.8 4.8v11.2c0 2.65 2.15 4.8 4.8 4.8h1.6v3.6a1.2 1.2 0 0 0 1.895.98zM17.98 23.2c-.495 0-.98.155-1.385.44-1.43 1.01-2.965 2.09-4.595 3.245V24.4a1.2 1.2 0 0 0-1.2-1.2H8a2.4 2.4 0 0 1-2.4-2.4V9.6A2.4 2.4 0 0 1 8 7.2h16a2.4 2.4 0 0 1 2.4 2.4v11.2a2.4 2.4 0 0 1-2.4 2.4zm-7.58-6.4c.885 0 1.6-.715 1.6-1.6s-.715-1.6-1.6-1.6-1.6.715-1.6 1.6.715 1.6 1.6 1.6m7.2-1.6c0-.885-.715-1.6-1.6-1.6s-1.6.715-1.6 1.6.715 1.6 1.6 1.6 1.6-.715 1.6-1.6m4 1.6c.885 0 1.6-.715 1.6-1.6s-.715-1.6-1.6-1.6-1.6.715-1.6 1.6.715 1.6 1.6 1.6" })
});
export default SvgChatRegularOptionsIcon;
